import { API } from './resources'

export default {
  addIframe: (data) => {
    return API.post('/iframe', data)
  },
  getIframes: (eventId) => {
    return API.get(`/iframe/${eventId}`)
  },
  getIframeBySlug: (route) => {
    return API.get('/iframe/slug', { params: { route } })
  },
  deleteIframe: (eventId) => {
    return API.delete(`/iframe/${eventId}`)
  },
  updateIframe: (eventId, data) => {
    return API.put(`/iframe/${eventId}`, data)
  }
}
